import { HttpRequest } from '../../components/HttpRequest';
import secureLocalStorage from 'react-secure-storage';

export const checkoutApi = {
  // Get available shipping regions for delivery
  async getShippingRegions() {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/get_shipping_regions`
      });

      // Handle the response structure properly
      if (response?.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response?.response?.data && Array.isArray(response.response.data)) {
        return response.response.data;
      }

      return [];
    } catch (error) {
      console.error('Error fetching shipping regions:', error);
      return [];
    }
  },

  // Get available pickup locations
  async getPickupLocations() {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/get_pickup_locations`
      });

      // Handle the response structure properly
      if (response?.data && Array.isArray(response.data)) {
        return response.data;
      } else if (response?.response?.data && Array.isArray(response.response.data)) {
        return response.response.data;
      }

      return [];
    } catch (error) {
      console.error('Error fetching pickup locations:', error);
      return [];
    }
  },

  // Get customer profile data
  async getCustomerProfile() {
    try {
      const customerId = secureLocalStorage.getItem("customerId") ?? secureLocalStorage.getItem("userId");
      if (!customerId) {
        return null;
      }

      const response = await HttpRequest({
        method: 'GET',
        url: `/api/get_parentcustomer_data?customerId=${customerId}`
      });

      if (response.status === 200 && response.response?.data) {
        return response.response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching customer profile:', error);
      return null;
    }
  },

  // Create order
  async createOrder(orderData) {
    try {
      const customerId = secureLocalStorage.getItem('customerId');
      if (!customerId) {
        throw new Error('Customer not logged in');
      }

      const payload = {
        ...orderData,
        customerId: customerId
      };

      const response = await HttpRequest({
        method: 'POST',
        url: `/api/v1/ecommerce/create_order`,
        body: payload
      });

      if (response.status === 200) {
        return {
          success: true,
          data: response.response?.data,
          message: response.response?.message
        };
      }

      return {
        success: false,
        message: response.response?.message || 'Failed to create order'
      };
    } catch (error) {
      console.error('Error creating order:', error);
      return {
        success: false,
        message: error.message || 'Failed to create order'
      };
    }
  },

  // Initiate payment (STK Push for M-Pesa, etc.)
  async initiatePayment(paymentData) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: `/api/v1/ecommerce/initiate_payment`,
        body: paymentData
      });

      return {
        success: response.status === 200,
        data: response.response?.data,
        message: response.response?.message
      };
    } catch (error) {
      console.error('Error initiating payment:', error);
      return {
        success: false,
        message: error.message || 'Failed to initiate payment'
      };
    }
  },

  // Check payment status
  async checkPaymentStatus(orderId) {
    try {
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/check_payment_status/${orderId}`
      });

      return {
        success: response.status === 200,
        status: response.response?.status,
        data: response.response?.data
      };
    } catch (error) {
      console.error('Error checking payment status:', error);
      return {
        success: false,
        status: 'pending'
      };
    }
  }
};